/* eslint-disable no-undef */
module.exports = (function() {
  'use strict';

  function post(url, body, succesCallback, errorCallback) {
    return $.ajax({
      type: 'POST',
      url: '/sitecoreapi/spa/digest',
      data: null,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      },
      success: function(data) {
        $.ajax({
          type: 'POST',
          url: url,
          data: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            __RequestVerificationToken: data
          },
          success: succesCallback,
          dataType: 'json'
        }).fail(function(jqXHR, textStatus) {
          errorCallback(jqXHR, textStatus);
        });
      },
      dataType: 'json'
    }).fail(function(jqXHR, textStatus) {
      errorCallback(jqXHR, textStatus);
    });
  }

  function get(url, succesCallback, errorCallback) {
    return $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      success: succesCallback,
      dataType: 'json'
    }).fail(function(jqXHR, textStatus) {
      errorCallback(jqXHR, textStatus);
    });
  }

  return {
    post: post,
    get: get
  };
})();
